import AppRoot from '../../../external/post-list-widget/containers/app-root';
import { withViewer } from '../../../external/common/hoc/with-viewer';

export default withViewer(AppRoot);
